import React from 'react'
import {
  ResponsesWrapper,
  Field,
  Label,
  Value
} from './style'

const labelMap = {
  'first_name': 'First Name',
  'last_name': 'Last Name',
  'full_name': 'Full Name',
  'email': 'Email',
  'mobile': 'Mobile Number',
  'country_code': 'Country Code',
  'gender': 'Gender',
  'date_of_birth': 'Date of Birth',
  'industry': 'Industry',
  'current_ctc': 'Current CTC',
  'current_ctc_fixed': 'Current CTC (Fixed)',
  'current_ctc_variable': 'Current CTC (Variable)',
  'total_years_of_experience': 'Total Years of Experience',
  'current_last_role_title': 'Current Last Role Title',
  'current_last_company_name': 'Current Last Company Name',
  'start_month_year': 'Start Month/Year',
  'end_month_year': 'End Month/Year',
  'select_choice': 'Select Choice',
  'select_dropdown': 'Select Dropdown',
  'education_pg_education_level': 'Education - PG Level',
  'education_ug_education_level': 'Education - UG Level',
  'education_tenth_education_level': 'Education - 10th Level',
  'education_diploma_education_level': 'Education - Diploma Level',
  'education_twelfth_education_level': 'Education - 12th Level',
}

const isUrl = (value) => {
  try {
    const url = new URL(value)
    return url.protocol === 'http:' || url.protocol === 'https:'
  } catch {
    return false
  }
}

const norm = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '')

const formatLabel = (key) => {
  return labelMap[key] || key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
}

// Look up the response_data key that corresponds to a given template question.
// Tries normalized match (handles "First Name" vs "first_name" vs "first name"),
// then falls back to labelMap (e.g. "Mobile Number" -> "mobile").
const findMatchingKey = (dataKeys, questionText) => {
  const target = norm(questionText)
  const direct = dataKeys.find(k => norm(k) === target)
  if (direct) return direct
  const alt = Object.entries(labelMap).find(([, v]) => norm(v) === target)
  if (alt && dataKeys.includes(alt[0])) return alt[0]
  return null
}

const ResponsesTab = ({ responseData, applicationFormTemplate }) => {
  const isPresent = (v) =>
    v !== null && v !== undefined && v !== ''

  const data = []
  const seen = new Set()

  if (responseData) {
    const dataKeys = Object.keys(responseData)
    const templateQuestions = [
      ...(applicationFormTemplate?.mandatoryQuestions || []),
      ...(applicationFormTemplate?.customQuestions || []),
    ]

    // Pin Submitted At to the top if present
    const submittedAtKey = dataKeys.find(k => norm(k) === 'submittedat')
    if (submittedAtKey && isPresent(responseData[submittedAtKey])) {
      seen.add(submittedAtKey)
      data.push({ label: 'Submitted At', value: responseData[submittedAtKey] })
    }

    // Render in template order
    for (const q of templateQuestions) {
      const key = findMatchingKey(dataKeys, q.question)
      if (key === null || seen.has(key)) continue
      seen.add(key)
      const value = responseData[key]
      if (!isPresent(value)) continue
      data.push({ label: q.question, value })
    }

    // Append any response keys not covered by the template
    for (const key of dataKeys) {
      if (seen.has(key)) continue
      const value = responseData[key]
      if (!isPresent(value)) continue
      data.push({ label: formatLabel(key), value })
    }
  }

  return (
    <ResponsesWrapper>
      {data.length > 0 ? (
        data.map((item, index) => (
          <Field key={index}>
            <Label>{item.label}</Label>
            <Value>
              {Array.isArray(item.value) ? (
                item.value.map((val, idx) =>
                  isUrl(val) ? (
                    <React.Fragment key={idx}>
                      <a
                        href={val}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Click here to view
                      </a>
                      {idx < item.value.length - 1 ? ', ' : ''}
                    </React.Fragment>
                  ) : (
                    <React.Fragment key={idx}>
                      {val}
                      {idx < item.value.length - 1 ? ', ' : ''}
                    </React.Fragment>
                  )
                )
              ) : isUrl(item.value) ? (
                <a
                  href={item.value}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Click here to view
                </a>
              ) : (
                item.value
              )}
            </Value>
          </Field>
        ))
      ) : (
        <div style={{ padding: '20px', color: '#999' }}>No response data available</div>
      )}
    </ResponsesWrapper>
  )
}

export default ResponsesTab
